import React, { Component } from 'react'
import MediaQuery from 'react-responsive'
import { css } from 'styled-components'
import ReactDOM from 'react-dom'
import Img from 'gatsby-image'

// Import themes modules
import { px2Rem } from '../../../themes/Mixins'
import TYPOGRAPHY from '../../../themes/Typography'

import Arrow from '../../common/Arrow'
import Title from '../../common/Title'
import CircleIcon from '../../common/CircleIcon'

import { FlexBox } from '../../common/Box'

import {
  Wrapper,
  WrapperImage,
  WrapperContext,
  DescriptionItem,
  WrapperDescription
} from './ProcessItemResponsive'

const ProcessWrapper = Wrapper.extend`
  @media (min-width: 768px) {
    .arrow-process {
      height: ${px2Rem(100)}!important;
      flex: auto;
    }
  }
`

export default class ProcessItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isAnimate: false
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll, false)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll, false)
  }

  handleScroll = () => {
    const offsetTop = ReactDOM.findDOMNode(this).getBoundingClientRect().top - window.innerHeight

    if (offsetTop <= 0) {
      this.setState({
        isAnimate: true
      })
    } else {
      this.setState({
        isAnimate: false
      })
    }
  }

  render() {
    const { item } = this.props
    const isIdeate = item.id === 'ideate'

    return (
      <MediaQuery maxWidth={767}>
        {
          (matches) => {
            const scale = matches ? 0.3 : 1
            const scaleItem = matches
              ? isIdeate
                ? scale + 0.21
                : scale + 0.11
              : scale

            return (
              <ProcessWrapper>
                <FlexBox
                  flexDirection='column'
                  alignItems='center'
                >
                  <CircleIcon
                    text={matches ? '' : item.iconText}
                    size={`calc(${px2Rem(150)}*${scale})`}
                  >
                    {item.icon(this.state.isAnimate, scaleItem)}
                  </CircleIcon>
                  <Arrow
                    className='arrow-process'
                    customStyle={{
                      margin: `${px2Rem(15)} 0`,
                      flex: '1'
                    }}
                  />
                </FlexBox>

                <WrapperContext>
                  {matches ?
                    <Title
                      title={item.iconText}
                      style={{
                        fontSize: `${TYPOGRAPHY.SIZE.xxTiny}`,
                        lineHeight: '1.93'
                      }}
                    />
                    : null
                  }
                  <WrapperDescription>
                    <DescriptionItem text={item.description} />
                  </WrapperDescription>
                  {
                    item.image &&
                    <WrapperImage iconName={isIdeate ? 'ideate' : 'design'}>
                      <img src={item.image} alt='Placeholder image' />
                    </WrapperImage>
                  }
                </WrapperContext>
              </ProcessWrapper>
            )
          }
        }
      </MediaQuery>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/process/ProcessItem.js